<template>
  <div class="safety_sheet">

    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupCheck
          ref="popupCheck"
          v-if="popup=='check'"
          :text="successText"
          @go="popupAction"
          @cancel="poupupEnter"
        ></PopupCheck>
        <PopupSuccess
          v-if="popup == 'success'"
          :text="successText"
          @check="poupupEnter"
        ></PopupSuccess>
        <PopupError
          v-if="popup == 'error'"
          :text="successText"
          @check="poupupEnter"
        ></PopupError>
      </Popup>
    </MyTransition>
    <section class="navigation">
      <div class="top flex" v-if="!insetStateBox">
        <button class="btn_primary" @click="insetStateBox = true">
          <i class="el-icon-plus"></i>新增安全衛生督導單、罰款單
        </button>
      </div>
      <div class="inner" v-else>
        <div>
          <div class="form_input flex">
            <label> 日期 </label>
            <div>
              <el-date-picker
                size="small"
                v-model="data.date"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="選擇日期"
                popper-class="picker-date"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="form_input flex">
            <label>承攬商</label>
            <div>
              <el-select
                filterable
                size="small"
                value-key="vendor_id"
                v-model="data.vendor_id"
                placeholder="選擇承攬商"
              >
                <el-option
                  v-for="item in options.vendor"
                  :key="item.vendor_id"
                  :label="item.vendor_chinese"
                  :value="item.vendor_id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="form_input flex">
            <label>類型</label>
            <div class="special_option">
              <el-checkbox-group v-model="data.type">
                <el-checkbox
                  v-for="(type, i) in options.type"
                  :key="i"
                  :label="type.value"
                  >{{ type.label }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>
          <div class="form_input flex">
            <label>備註</label>
            <div>
              <textarea v-model="data.remark" class="input_primary"></textarea>
            </div>
          </div>
        </div>
        <div class="inner_btn flex">
          <button class="btn_gray" @click="insetStateBox = false">取消</button>
          <button class="btn_primary" @click="createSheet">送出</button>
        </div>
      </div>
    </section>
    <section class="search_block">
      <Search
        :filed="searchField"
        :searchAction="searchAction"
        :searchStatus="searchStatus"
      ></Search>
    </section>
    <section class="costruction table_outter_block">
      <Loading part></Loading>
      <div v-if="tableData.length !== 0">
        <PersonalTable>
          <TableThead
            :thead="thead"
            :thead_scroll="thead_scroll"
            slot="thead"
            @tableSort="tableSort"
            @eventGetHeight="eventGetHeight"
          ></TableThead>
          <div
            class="personal_data_table"
            slot="tbody"
            :style="`top:${table_head_heigh}px;  height:calc(100vh - ${
              430 - table_head_heigh
            }px);`"
            @scroll="scrollEvent"
          >
            <table>
              <colgroup>
                <col
                  v-for="(th, index) in thead"
                  :key="index"
                  :width="th.width"
                />
              </colgroup>
              <tbody>
                <template v-for="(data, index) in pageData">
                  <tr :key="`application_${index}`">
                    <template v-for="(th, th_index) in thead">
                      <!--展開每日施工單-->
                      <td
                        v-if="th.value == 'action'"
                        :key="`action_${th_index}`"
                      >
                        <div class="table_action flex">
                          <div @click="deleteItem(data, index)">
                            <i class="el-icon-delete"></i>
                          </div>
                          <div>
                            <label :for="`paper_upload${index}`">
                              <i class="el-icon-upload"></i>
                            </label>
                            <input
                              :id="`paper_upload${index}`"
                              type="file"
                              @change="paperUpload($event, data)"
                            />
                          </div>
                          <div :class="data.file?false:'black'" @click="data.file&&link(data.file.path)">
                            <i class="el-icon-view"></i>
                          </div>
                        </div>
                      </td>
                      <td
                        v-else-if="th.value.includes('.')"
                        :key="`trans_${th_index}`"
                      >
                        {{ transfromData(th.value, data) }}
                      </td>
                      <!--array--->
                      <td
                        v-else-if="Array.isArray(data[th.value])"
                        :key="`array_${th_index}`"
                      >
                        <p v-for="(item, i) in data[th.value]" :key="i">
                          {{ item }}
                        </p>
                      </td>
                      <!--default-->
                      <td
                        :class="th.align == 'center' ? 'text_center' : false"
                        :key="`data_${th_index}`"
                        v-else
                      >
                        {{ data[th.value] }}
                      </td>
                    </template>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </PersonalTable>
        <el-pagination
          :page-size="page.size + 1"
          :pager-count="11"
          layout="prev, pager, next"
          :total="page.allPage"
          @current-change="pageChange"
        ></el-pagination>
      </div>
      <div class="no_data"  v-else-if="this.$store.state.loading==false">
        <i class="el-icon-warning-outline"></i>
        <p>NO Data</p>
      </div>
    </section>
  </div>
</template>

<style lang="scss">
.safety_sheet {
  .navigation {
    .top {
      margin-bottom: 10px;
      button {
        width: 250px;
      }
    }
    .inner {
      text-align: left;
      background: #fff;
      margin: 15px 0;
      border-radius: 15px;
      border: 1px solid #e6e6e6;
      padding: 15px 20px;
      .form_input {
        flex-wrap: wrap;
        white-space: nowrap;
        .notice_textarea {
          min-height: 50px;
        }
        label {
          flex: 2;
          color: #999;
          font-weight: bold;
          span {
            color: var(--subColor);
          }
        }
        > div {
          flex: 8;
          input,
          textarea {
            width: 100%;
          }
        }
        .special_option {
          max-width: 100%;
          label {
            &.is-checked {
              span {
                color: #409eff;
                font-weight: bold;
              }
            }
          }
          span {
            color: var(--fontGray);
          }
          .el-checkbox-group {
            // display: flex;
            // flex-wrap: wrap;
            // justify-content: left;
            label {
              font-weight: normal;
            }
          }
        }
      }
      .inner_btn {
        justify-content: flex-end;
        button {
          width: 100px;
          margin: 0 5px;
        }
      }
    }
  }
  table {
    .table_action {
      cursor: pointer;
      > div {
        i {
          cursor: pointer;
          &:hover {
            color: #fff;
          }
        }
        background: #efefef;
        padding: 4px;
        border-radius: 3px;
        margin: 0 10px 0 0;
        > input {
          display: none;
        }
        &:hover {
          transform: scale(1.1);
          color: #fff;
          background: var(--mainColor);
        }
      }
      .black{
        background: #7d7d7d;
        i{
            cursor:not-allowed ;
        }
        &:hover{
          cursor:not-allowed ;
          background: #545454;
        }
      }
    }
  }
}
// 隱藏el-date-picker的header中, 年份的前後按鈕
.picker-date {
    .el-date-picker__header {
        button:nth-child(1) {
            display: none;
        }
        button:nth-child(5) {
            display: none;
        }
    }
}
</style>
<script>
import TableThead from "@/components/global/table/components/TableFixHead";
import PersonalTable from "@/components/global/table/PersonalTable.global";
import mixins from "@/components/mixins.js";
import Options from "@/utils/options";
import Search from "@/components/global/Search";
export default {
  name: "safetySheet",
  mixins: [mixins],
  components: {
    TableThead,
    PersonalTable,
    Search,
  },
  data() {
    return {
      tableData: [],
      insetStateBox: false,
      searchStatus: false,
      thead_scroll: 0,
      table_head_heigh: 50,
      thead: [
        {
          name: "操作",
          width: "80",
          value: "action",
        },
        {
          name: "時間",
          width: "100px",
          value: "date",
        },
        {
          name: "供應商",
          width: "90px",
          value: "vendor.vendor_chinese",
        },
        {
          name: "類型",
          width: "50px",
          value: "type",
        },
        {
          name: "備註",
          width: "90px",
          value: "remark",
        },
      ],
      data: {
        type: [],
        date: "",
        vendor_id: "",
        remark: "",
      },
      options: {
        vendor: [],
        type: [
          {
            label: "告發單",
            value: "告發單",
          },
          {
            label: "停工單",
            value: "停工單",
          },
          {
            label: "罰款單",
            value: "罰款單",
          },
        ],
      },
      popupStatus: false,
      successText: null,
      popup: null,
      page: {
        size: 7,
        page: 1,
        allPage: null,
      },
      actionIndex:null,
    };
  },
  computed: {
    searchField() {
      return [
        {
          label: "承攬商",
          value: "vendor_id",
          type: "select",
          options: this.options.vendor,
          options_value: "vendor_id",
          options_label: "vendor_chinese",
        },
        {
          label: "開始時間",
          value: "start_date",
          type: "date",
          options: null,
        },
        {
          label: "結束時間",
          value: "end_date",
          type: "date",
          options: null,
        },
        {
          label: "類型",
          value: "type",
          type: "select",
          multi: true,
          options: this.options.type,
          options_value: "value",
          options_label: "label",
        },
      ];
    },
    pageData() {
      const list = [];
      for (
        let i = this.page.size * (this.page.page - 1);
        i < this.page.page * this.page.size;
        i++
      ) {
        if (this.tableData[i]) {
          list.push(this.tableData[i]);
        }
      }
      return list;
    },
  },
  methods: {
    scrollEvent(el) {
      this.thead_scroll = el.target.scrollLeft;
    },
    async getOptions() {
      this.options.vendor = await Options.getVendor();
    },
    eventGetHeight(height) {
      this.table_head_heigh = height;
    },
    tableSort(sort_attr) {
      //關閉展開細向
      if (sort_attr.includes("_sort")) {
        //順排
        const attr = sort_attr.split("_sort")[0];
        this.tableData = this.isSort({
          data: this.tableData,
          attr: attr,
          type: "sort",
        });
      } else {
        //逆排
        this.tableData = this.isSort({
          data: this.tableData,
          attr: sort_attr,
          type: "reverse",
        });
      }
    },
    getData({ search }) {
      this.$store.commit("loadingAction", true);
      this.$http.api.admin.getSafety({ params: search }).then((res) => {
        this.searchStatus = false;
        this.page.allPage = res.data.length;
        this.tableData = res.data;
        this.$store.commit("loadingAction", false);
      });
    },
    searchAction(search) {
      this.searchStatus = true;
      this.getData({
        search: search,
      });
    },
    createSheet() {
      this.$http.api.admin
        .postSafety(this.data)
        .then((res) => {
          this.insetStateBox = false;
          this.popupStatus = true;
          this.successText = "新增成功";
          this.popup = "success";
        })
        .catch((error) => {
          console.error(error);
          this.popupStatus = true;
          this.popup = "error";
          this.successText = "新增失敗";
        });
    },
    pageChange(value) {
      this.page.page = value;
      //改變頁數先關閉展開係向
      this.inner_status = false;
      this.inner_status_index = null;
    },
    poupupEnter() {
      this.popupStatus = false;
      if (this.popup == "success") {
        this.getData({});
      }
    },
    transfromData(th, data) {
      if (th.includes(".")) {
        const innerKey = th.split(".");
        return data[innerKey[0]][innerKey[1]];
      } else if (th.includes("[]")) {
        const innerKey = th.split("[]")[0];
        let options = [];
        let options_key = null;
        for (let option_key in this.options) {
          if (innerKey.includes(option_key)) {
            options = this.options[option_key];
            options_key = option_key;
          }
        }
        return options
          .filter((el) => {
            return data[innerKey].includes(
              el[this.options[`${options_key}_value`]]
            );
          })
          .map((el) => {
            return el[this.options[`${options_key}_key`]];
          });
      } else {
        return data[th];
      }
    },
    deleteItem(data) {
      this.actionIndex = data.id;
      this.popupStatus = true;
      this.successText = "確定刪除嗎";
      this.popup = "check";

    },
    popupAction(){
      this.$http.api.admin
        .deleteSafety(this.actionIndex)
        .then((res) => {
          this.actionIndex=null
          this.popupStatus = true;
          this.successText = "刪除成功";
          this.popup = "success";
        })
        .catch((error) => {
          this.popupStatus = true;
          this.popup = "error";
          this.successText = "刪除失敗";
        });
    },
    paperUpload(e, data) {
      const name = e.target.files[0].name;
      const formData = new FormData();
      formData.append("file", e.target.files[0]); //放進上傳的檔案
      this.$http.api.admin
        .safetyUpload(data.id, formData)
        .then((res) => {
          this.popupStatus = true;
          this.successText = "上傳成功";
          this.popup = "success";
        })
        .catch((error) => {
          this.popupStatus = true;
          this.popup = "error";
          this.successText = "上傳失敗";
        });
    },
  },
  created() {
    this.$store.commit("loadingAction", null);
    this.getOptions();
    this.getData({});
  },
};
</script>
